// ════════════════════════════════════
// i18n.ts — TolkX Translations
// ════════════════════════════════════

export type Lang = 'ES' | 'EN';

export const translations = {
  ES: {
    // ── Landing ──
    landing: {
      badge: 'Beta · Cifrado E2E',
      tagline: 'Conecta sin límites.',
      sub: 'Mensajes, llamadas y más — cifrado de extremo a extremo, siempre.',
      login: 'Iniciar Sesión',
      signup: 'Crear Cuenta',
      feature1Title: 'Mensajería Instantánea',
      feature1Desc: 'Chats en tiempo real con soporte multimedia, reacciones y hilos.',
      feature2Title: 'Llamadas Seguras',
      feature2Desc: 'Audio y video cifrado end-to-end sin comprometer la calidad.',
      feature3Title: 'Privacidad Total',
      feature3Desc: 'Tus datos son tuyos. Sin anuncios, sin rastreo, sin concesiones.',
      cta: '¡Empieza gratis hoy!',
      footer: '© 2025 TolkX',
    },
    // ── Login ──
    login: {
      title: 'Iniciar sesión',
      email: 'Correo electrónico',
      emailPlaceholder: 'correo@ejemplo.com',
      password: 'Contraseña',
      passwordPlaceholder: 'Tu contraseña',
      forgot: '¿Olvidaste tu contraseña?',
      submit: 'Iniciar Sesión',
      loading: 'Entrando...',
      or: 'o',
      google: 'Continuar con Google',
      facebook: 'Continuar con Facebook',
      phone: 'Continuar con Teléfono',
      noAccount: '¿Nuevo en TolkX?',
      createAccount: 'Crear una cuenta',
      errorEmpty: 'Completa todos los campos.',
      errorCredentials: 'Correo o contraseña incorrectos.',
      resetSuccess: '✓ Revisa tu correo para restablecer tu contraseña.',
      resetEmailError: 'Ingresa tu correo primero.',
      resetNotFound: 'No encontramos una cuenta con ese correo.',
    },
    // ── Register ──
    register: {
      title: 'Crear cuenta',
      sub: 'Elige cómo quieres registrarte',
      google: 'Continuar con Google',
      facebook: 'Continuar con Facebook',
      phone: 'Continuar con Teléfono',
      orEmail: 'O REGÍSTRATE CON EMAIL',
      emailBtn: 'Registrarse con correo',
      hasAccount: '¿Ya tienes cuenta?',
      loginLink: 'Iniciar sesión',
      // Form
      formTitle: 'Crea tu perfil',
      formSub: 'Elige tu usuario y credenciales',
      back: '← Volver',
      username: 'Nombre de usuario',
      usernamePlaceholder: 'tu_usuario',
      usernameAvailable: '¡Disponible!',
      usernameTaken: 'Este usuario ya está tomado.',
      emailLabel: 'Correo electrónico',
      emailPlaceholder: 'correo@ejemplo.com',
      passwordLabel: 'Contraseña',
      passwordPlaceholder: 'Crea tu contraseña',
      confirmLabel: 'Confirmar contraseña',
      confirmPlaceholder: 'Repite tu contraseña',
      confirmMatch: '¡Coinciden!',
      confirmNoMatch: 'Las contraseñas no coinciden.',
      strengthWeak: 'Débil',
      strengthFair: 'Regular',
      strengthGood: 'Buena',
      strengthStrong: 'Fuerte',
      submit: 'Crear cuenta →',
      loading: 'Creando cuenta...',
      // Phone
      phoneTitle: 'Tu número',
      phoneSub: 'Te enviaremos un código SMS',
      phoneLabel: 'Número de teléfono',
      phonePlaceholder: '+1 809 000 0000',
      phoneSend: 'Enviar código SMS →',
      phoneSending: 'Enviando...',
      // OTP
      otpTitle: 'Verifica tu número',
      otpLabel: 'Código SMS',
      otpVerify: 'Verificar →',
      otpVerifying: 'Verificando...',
      otpError: 'Código incorrecto. Intenta de nuevo.',
      // Verify email
      verifyTitle: 'Verifica tu correo',
      verifySub: 'Enviamos un link a',
      verifyBtn: 'Ya verifiqué → Iniciar sesión',
      verifyResend: 'Reenviar',
      verifyNoArrived: '¿No llegó?',
      // Choose username
      chooseTitle: 'Elige tu usuario',
      chooseSub: 'Elige tu nombre único en TolkX y una contraseña de respaldo.',
      backupPassword: 'Contraseña de respaldo',
      backupPlaceholder: 'Crea una contraseña',
      saveBtn: 'Entrar a TolkX →',
      saving: 'Guardando...',
      // Errors
      errorUsername: 'Elige un nombre de usuario disponible.',
      errorPasswordWeak: 'La contraseña es muy débil.',
      errorPasswordShort: 'La contraseña debe tener al menos 6 caracteres.',
      errorNoSession: 'No hay sesión activa.',
    },

    // ── Chat ──
    chat: {
      searchPlaceholder: 'Buscar chats o mensajes...',
      noChats: 'No tienes chats aún',
      noMessages: 'Sin mensajes aún',
      friends: 'Amigos',
      chats: 'Chats',
      pinned: 'Fijados',
      archived: 'Archivados',
      online: 'En línea',
      offline: 'Desconectado',
      typing: 'Escribiendo...',
      writeMessage: 'Escribe un mensaje...',
      send: 'Enviar',
      reply: 'Responder',
      edit: 'Editar',
      delete: 'Eliminar',
      forward: 'Reenviar',
      pin: 'Fijar',
      unpin: 'Desfijar',
      pinChat: 'Fijar chat',
      unpinChat: 'Desfijar chat',
      archive: 'Archivar',
      unarchive: 'Desarchivar',
      sendMessage: 'Enviar mensaje',
      deleteChat: 'Borrar chat',
      blockUser: 'Bloquear usuario',
      unblockUser: 'Desbloquear',
      pinnedMessage: 'Mensaje fijado',
      pinnedMessages: 'mensajes fijados',
      disappearTimer: 'Mensajes temporales',
      disappearOff: 'Desactivar',
      photo: 'Foto',
      file: 'Archivo',
      poll: 'Encuesta',
      location: 'Ubicación',
      stopLocation: 'Detener ubicación',
      audio: '🎤 Audio',
      gif: '🎬 GIF',
      image: '📷 Imagen',
      newPoll: 'Nueva encuesta',
      pollQuestion: 'Pregunta...',
      pollOption: 'Opción',
      addOption: '+ Agregar opción',
      sendPoll: 'Enviar encuesta',
      votes: 'votos',
      vote: 'voto',
      scheduleMessage: 'Programar mensaje',
      scheduledMessages: 'Mensajes programados',
      editProfile: '✏️ Editar perfil',
      myQR: 'Mi QR y enlace',
      copyLink: 'Copiar enlace',
      copied: '✓ Copiado',
      downloadQR: 'Descargar QR',
      settings: 'Configuraciones',
      logout: 'Cerrar sesión',
      deleteAccount: 'Eliminar cuenta',
      theme: 'Temas del chat',
      privacy: 'Privacidad',
      support: 'Soporte',
      about: 'Acerca de TolkX',
      language: 'Idioma',
      darkMode: 'Modo oscuro',
      lightMode: 'Modo claro',
      addFriend: 'Agregar amigo',
      createGroup: 'Crear grupo',
      searchUsers: 'Buscar por @usuario',
      search: 'Buscar',
      cancel: 'Cancelar',
      save: 'Guardar cambios',
      saving: 'Guardando...',
      displayName: 'Nombre para mostrar',
      bio: 'Bio',
      seenBy: 'Visto por',
      nobodySeen: 'Nadie lo ha visto aún',
    },
  },

  EN: {
    // ── Landing ──
    landing: {
      badge: 'Beta · E2E Encrypted',
      tagline: 'Connect without limits.',
      sub: 'Messages, calls and more — end-to-end encrypted, always.',
      login: 'Sign In',
      signup: 'Create Account',
      feature1Title: 'Instant Messaging',
      feature1Desc: 'Real-time chats with multimedia support, reactions and threads.',
      feature2Title: 'Secure Calls',
      feature2Desc: 'End-to-end encrypted audio and video without sacrificing quality.',
      feature3Title: 'Full Privacy',
      feature3Desc: 'Your data is yours. No ads, no tracking, no compromises.',
      cta: 'Start free today!',
      footer: '© 2025 TolkX',
    },
    // ── Login ──
    login: {
      title: 'Sign in',
      email: 'Email address',
      emailPlaceholder: 'email@example.com',
      password: 'Password',
      passwordPlaceholder: 'Your password',
      forgot: 'Forgot your password?',
      submit: 'Sign In',
      loading: 'Signing in...',
      or: 'or',
      google: 'Continue with Google',
      facebook: 'Continue with Facebook',
      phone: 'Continue with Phone',
      noAccount: 'New to TolkX?',
      createAccount: 'Create an account',
      errorEmpty: 'Please fill in all fields.',
      errorCredentials: 'Incorrect email or password.',
      resetSuccess: '✓ Check your email to reset your password.',
      resetEmailError: 'Please enter your email first.',
      resetNotFound: 'We could not find an account with that email.',
    },
    // ── Register ──
    register: {
      title: 'Create account',
      sub: 'Choose how you want to sign up',
      google: 'Continue with Google',
      facebook: 'Continue with Facebook',
      phone: 'Continue with Phone',
      orEmail: 'OR SIGN UP WITH EMAIL',
      emailBtn: 'Sign up with email',
      hasAccount: 'Already have an account?',
      loginLink: 'Sign in',
      // Form
      formTitle: 'Create your profile',
      formSub: 'Choose your username and credentials',
      back: '← Back',
      username: 'Username',
      usernamePlaceholder: 'your_username',
      usernameAvailable: 'Available!',
      usernameTaken: 'This username is already taken.',
      emailLabel: 'Email address',
      emailPlaceholder: 'email@example.com',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Create your password',
      confirmLabel: 'Confirm password',
      confirmPlaceholder: 'Repeat your password',
      confirmMatch: 'Passwords match!',
      confirmNoMatch: 'Passwords do not match.',
      strengthWeak: 'Weak',
      strengthFair: 'Fair',
      strengthGood: 'Good',
      strengthStrong: 'Strong',
      submit: 'Create account →',
      loading: 'Creating account...',
      // Phone
      phoneTitle: 'Your number',
      phoneSub: 'We will send you an SMS code',
      phoneLabel: 'Phone number',
      phonePlaceholder: '+1 809 000 0000',
      phoneSend: 'Send SMS code →',
      phoneSending: 'Sending...',
      // OTP
      otpTitle: 'Verify your number',
      otpLabel: 'SMS Code',
      otpVerify: 'Verify →',
      otpVerifying: 'Verifying...',
      otpError: 'Incorrect code. Please try again.',
      // Verify email
      verifyTitle: 'Verify your email',
      verifySub: 'We sent a link to',
      verifyBtn: 'I verified → Sign in',
      verifyResend: 'Resend',
      verifyNoArrived: "Didn't arrive?",
      // Choose username
      chooseTitle: 'Choose your username',
      chooseSub: 'Pick your unique TolkX name and a backup password.',
      backupPassword: 'Backup password',
      backupPlaceholder: 'Create a password',
      saveBtn: 'Enter TolkX →',
      saving: 'Saving...',
      // Errors
      errorUsername: 'Choose an available username.',
      errorPasswordWeak: 'Password is too weak.',
      errorPasswordShort: 'Password must be at least 6 characters.',
      errorNoSession: 'No active session.',
    },
    // ── Chat ──
    chat: {
      searchPlaceholder: 'Search chats or messages...',
      noChats: 'No chats yet',
      noMessages: 'No messages yet',
      friends: 'Friends',
      chats: 'Chats',
      pinned: 'Pinned',
      archived: 'Archived',
      online: 'Online',
      offline: 'Offline',
      typing: 'Typing...',
      writeMessage: 'Write a message...',
      send: 'Send',
      reply: 'Reply',
      edit: 'Edit',
      delete: 'Delete',
      forward: 'Forward',
      pin: 'Pin',
      unpin: 'Unpin',
      pinChat: 'Pin chat',
      unpinChat: 'Unpin chat',
      archive: 'Archive',
      unarchive: 'Unarchive',
      sendMessage: 'Send message',
      deleteChat: 'Delete chat',
      blockUser: 'Block user',
      unblockUser: 'Unblock',
      pinnedMessage: 'Pinned message',
      pinnedMessages: 'pinned messages',
      disappearTimer: 'Disappearing messages',
      disappearOff: 'Disable',
      photo: 'Photo',
      file: 'File',
      poll: 'Poll',
      location: 'Location',
      stopLocation: 'Stop location',
      audio: '🎤 Audio',
      gif: '🎬 GIF',
      image: '📷 Image',
      newPoll: 'New poll',
      pollQuestion: 'Question...',
      pollOption: 'Option',
      addOption: '+ Add option',
      sendPoll: 'Send poll',
      votes: 'votes',
      vote: 'vote',
      scheduleMessage: 'Schedule message',
      scheduledMessages: 'Scheduled messages',
      editProfile: '✏️ Edit profile',
      myQR: 'My QR & link',
      copyLink: 'Copy link',
      copied: '✓ Copied',
      downloadQR: 'Download QR',
      settings: 'Settings',
      logout: 'Sign out',
      deleteAccount: 'Delete account',
      theme: 'Chat themes',
      privacy: 'Privacy',
      support: 'Support',
      about: 'About TolkX',
      language: 'Language',
      darkMode: 'Dark mode',
      lightMode: 'Light mode',
      addFriend: 'Add friend',
      createGroup: 'Create group',
      searchUsers: 'Search by @username',
      search: 'Search',
      cancel: 'Cancel',
      save: 'Save changes',
      saving: 'Saving...',
      displayName: 'Display name',
      bio: 'Bio',
      seenBy: 'Seen by',
      nobodySeen: 'Nobody has seen this yet',
    },
  },
};